export class GetAllAttributeDropDown {
    attributeName: string;
    id: number;
    constructor(
        attributeName: string,
        id: number
    ) {
        this.attributeName = attributeName;
        this.id = id;
    }
}